namespace('compass.hotel');


compass.hotel.HotelImageGalleryWidget = compass.defineWidget(function HotelImageGalleryWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	

	var _setupControls = this.setupControls = function() {
		var d = _d;
		 	
	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		widgetElem.append(
			d.div({ className : 'hotelImageGalleryDiv' }, 
				me.drawImgs()
			)
		);
		var largeImageDiv = d.div({className:'largeImageDiv'},
			d.div({className:'imageDivGalleryLinkDiv'},
				d.a({href:'javascript:;', className:"imageDivGalleryLink"}, "Return to Gallery")
			).activate(function(){
				me.find('.largeImageDiv').hide();
				me.find('.hotelImageGalleryDiv').fadeIn(200, function(){
					me.find('.hotelImageGalleryDiv').masonry({
	 					itemSelector : '.hotelGalleryImgDiv'
	  				});
					var bricks = me.find('.hotelGalleryImgDiv');
					if ( bricks.length > 0 ) bricks[0].focus();
				});
			}),
			d.div({className:'leftNavDiv icon-stack', role: 'button', 'aria-role': 'button', 'aria-label': 'previous image', tabindex: 0},
				d.i({ className : 'fa-regular fa-circle-chevron-left' })
			),
			d.div({className:'rightNavDiv icon-stack', role: 'button', 'aria-role': 'button', 'aria-label': 'next image', tabindex: 0},
				d.i({ className : 'fa-regular fa-circle-chevron-right' })
			),
			d.div({className:'imageContainerDiv'})
		);
		widgetElem.append(largeImageDiv);

		$(window).on('resize', function() { // This event only seems to properly fire when bound to the window, luckily this widget has a destroy method that gets called
			jQuery('.hotelImageGalleryDiv').masonry({
 					itemSelector : '.hotelGalleryImgDiv'
			});
		});

		_setupControls();
	};

	this.drawImgs = function() {
		var d = _d;

		var divs = [];
		var singleDiv = {};
		for(var i = 0; i < _settings.images.length; i++) {
			var linkUrl = (_settings.images[i].link) ? _settings.images[i].link : _settings.images[i]["links"]["350px"]["href"];
			divs.push(d.div({ className : 'hotelGalleryImgDiv', role : 'button', 'aria-role' : 'button', tabindex : 0 },
				d.img({className : 'hotelGalleryImg',
					src : linkUrl,
					index: i
				})
			).activate((function(index) {
				return function() {
					me.showLargeImage(index);
				};
			})(i))
			);
		}

		return divs;

	};
	
	this.showLargeImage = function(index){
		var d = _d;
		var prevImage = index - 1;
		var nextImage = index + 1;

		if (index == (_settings.images.length - 1)){
			nextImage = 0;
		}
		if (index === 0){
			prevImage = _settings.images.length - 1;
		}
		
		me.find('.imageContainerDiv').hide().empty().unbind();
		me.find('.leftNavDiv,.rightNavDiv').unbind();
		me.find('.imageContainerDiv').append(d.img({className:'largeImage',
			src: (_settings.images[index].link) ? _settings.images[index].link : _settings.images[index]["links"]["1000px"]["href"]
		}));
		me.find('.imageContainerDiv').fadeIn(400);
		me.find('.hotelImageGalleryDiv').hide();
		me.find('.leftNavDiv').activate(function(){
			me.showLargeImage(prevImage);
			});
		me.find('.rightNavDiv,.imageContainerDiv').activate(function(){
			me.showLargeImage(nextImage);
			});

		me.find('.largeImageDiv').fadeIn(200);
	};
	
	this.destroyWidget = function(){
		$(window).off('resize');
		me.find(".imagesWrapper").remove();
	};
	
	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultHotelImageGalleryWidgetWUID',
	widgetName : 'HotelImageGalleryWidget',
	imgPath : '/resources/img',
	subclass : false,
	imgs : []
});
